/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoTraceCandidate } from './OutputGeoTraceCandidate';
import {
    OutputGeoTraceCandidateFromJSON,
    OutputGeoTraceCandidateFromJSONTyped,
    OutputGeoTraceCandidateToJSON,
} from './OutputGeoTraceCandidate';

/**
 * 
 * @export
 * @interface OutputGeoTraceToken
 */
export interface OutputGeoTraceToken {
    /**
     * 
     * @type {Array<OutputGeoTraceCandidate>}
     * @memberof OutputGeoTraceToken
     */
    alone?: Array<OutputGeoTraceCandidate>;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceToken
     */
    index?: number;
    /**
     * launch | waypoint | target
     * @type {string}
     * @memberof OutputGeoTraceToken
     */
    kind?: string;
    /**
     * 
     * @type {Array<OutputGeoTraceCandidate>}
     * @memberof OutputGeoTraceToken
     */
    merged?: Array<OutputGeoTraceCandidate>;
    /**
     * MergedText — склеєний варіант "цей-наступний", який пробувався як одна назва.
     * @type {string}
     * @memberof OutputGeoTraceToken
     */
    mergedText?: string;
    /**
     * SoftAfter — стик із наступним токеном м'який (голий дефіс), тобто пара могла бути
     * однією дефісною назвою. Тоді заповнений Merged.
     * @type {boolean}
     * @memberof OutputGeoTraceToken
     */
    softAfter?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceToken
     */
    text?: string;
}

/**
 * Check if a given object implements the OutputGeoTraceToken interface.
 */
export function instanceOfOutputGeoTraceToken(value: object): boolean {
    return true;
}

export function OutputGeoTraceTokenFromJSON(json: any): OutputGeoTraceToken {
    return OutputGeoTraceTokenFromJSONTyped(json, false);
}

export function OutputGeoTraceTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceToken {
    if (json == null) {
        return json;
    }
    return {
        
        'alone': json['alone'] == null ? undefined : ((json['alone'] as Array<any>).map(OutputGeoTraceCandidateFromJSON)),
        'index': json['index'] == null ? undefined : json['index'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'merged': json['merged'] == null ? undefined : ((json['merged'] as Array<any>).map(OutputGeoTraceCandidateFromJSON)),
        'mergedText': json['mergedText'] == null ? undefined : json['mergedText'],
        'softAfter': json['softAfter'] == null ? undefined : json['softAfter'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function OutputGeoTraceTokenToJSON(value?: OutputGeoTraceToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alone': value['alone'] == null ? undefined : ((value['alone'] as Array<any>).map(OutputGeoTraceCandidateToJSON)),
        'index': value['index'],
        'kind': value['kind'],
        'merged': value['merged'] == null ? undefined : ((value['merged'] as Array<any>).map(OutputGeoTraceCandidateToJSON)),
        'mergedText': value['mergedText'],
        'softAfter': value['softAfter'],
        'text': value['text'],
    };
}

